import { setTheme } from "theme/default/setTheme";

export const setBorderRadius_50p = setTheme(({ theme }) => `border-radius: ${theme.borderRadius.border_radius_50p}`);
